/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Provider_AnthropicInputs */

const en_byoa_provider_anthropic = /** @type {(inputs: Byoa_Provider_AnthropicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anthropic (Claude)`)
};

const id_byoa_provider_anthropic = /** @type {(inputs: Byoa_Provider_AnthropicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anthropic (Claude)`)
};

/**
* | output |
* | --- |
* | "Anthropic (Claude)" |
*
* @param {Byoa_Provider_AnthropicInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_provider_anthropic = /** @type {((inputs?: Byoa_Provider_AnthropicInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Provider_AnthropicInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_provider_anthropic(inputs)
	return en_byoa_provider_anthropic(inputs)
});